import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Settings, Package, UtensilsCrossed, ClipboardList, Zap, Users } from 'lucide-react';
const MENU_ITEMS = [{
  icon: LayoutDashboard,
  label: 'AI Analytics',
  path: '/'
}, {
  icon: Settings,
  label: 'Operations',
  path: '/operations/team'
}, {
  icon: Package,
  label: 'Orders',
  path: '/orders'
}, {
  icon: UtensilsCrossed,
  label: 'Menu Management',
  path: '/menu'
}, {
  icon: ClipboardList,
  label: 'Procedures',
  path: '/procedures'
}, {
  icon: Zap,
  label: 'Setup',
  path: '/setup'
}, {
  icon: Users,
  label: 'Customers',
  path: '/customers'
}];
export function Sidebar() {
  const location = useLocation();
  return <div className="w-64 bg-background-elevated border-r border-white/10 flex flex-col h-screen fixed left-0 top-0" data-id="element-173">
      <div className="p-6" data-id="element-174">
        <h1 className="text-2xl font-bold text-accent-primary" data-id="element-175">Collina</h1>
        <p className="text-xs text-text-secondary mt-1" data-id="element-176">
          Restaurant Management
        </p>
      </div>

      <nav className="flex-1 px-4 space-y-2" data-id="element-177">
        {MENU_ITEMS.map(item => {
        const isActive = location.pathname === item.path || item.path !== '/' && location.pathname.startsWith(item.path);
        return <Link key={item.path} to={item.path} className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${isActive ? 'bg-accent-primary/10 text-accent-primary' : 'text-text-secondary hover:bg-white/5 hover:text-text-primary'}`} data-id="element-178">
              <item.icon size={20} data-id="element-179" />
              <span className="font-medium" data-id="element-180">{item.label}</span>
            </Link>;
      })}
      </nav>

      <div className="p-4 border-t border-white/10" data-id="element-181">
        <div className="flex items-center gap-3 px-4 py-3" data-id="element-182">
          <div className="w-8 h-8 rounded-full bg-accent-primary flex items-center justify-center text-white font-bold" data-id="element-183">
            M
          </div>
          <div data-id="element-184">
            <div className="text-sm font-medium text-text-primary" data-id="element-185">Marko</div>
            <div className="text-xs text-text-secondary" data-id="element-186">Owner</div>
          </div>
        </div>
      </div>
    </div>;
}